export default "__VITE_ASSET__CTtrKbzy__"